type ControlMode = 'Hide' | 'Simplified' | 'Detailed';

const resolveControlMode = (
  controls: ControlMode | null | undefined,
): ControlMode => controls ?? 'Hide';

const isYouTubeUrl = (url: string | null | undefined): boolean => {
  if (!url) {
    return false;
  }

  return /youtube\.com|youtu\.be|youtube-nocookie\.com/i.test(url);
};

const isDirectVideoUrl = (url: string | null | undefined): boolean =>
  Boolean(url && !isYouTubeUrl(url));

const isBackgroundVideo = (
  controlMode: ControlMode,
  autoplay: boolean | null | undefined,
): boolean => controlMode === 'Hide' && Boolean(autoplay);

export type { ControlMode };
export {
  isBackgroundVideo,
  isDirectVideoUrl,
  isYouTubeUrl,
  resolveControlMode,
};
